import { render, staticRenderFns } from "./BaseBuild.vue?vue&type=template&id=05ff73df&"
import script from "./BaseBuild.vue?vue&type=script&lang=js&"
export * from "./BaseBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports